import React, { FC } from 'react';
interface TInput {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  lable?: string;
  name?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disable?:boolean
}

export const Input: FC<TInput> = (props) => {
  const { onChange, lable, name, type, value, placeholder,disable } = props;
  return (
    <div>
      <label className="mb-2.5 block font-medium text-black dark:text-white">
        {lable}
      </label>
      <div className="relative">
        <input
          name={name}
          type={type}
          onChange={onChange}
          value={value}
          disabled={disable}
          placeholder={placeholder}
          className="w-full rounded-lg border border-stroke bg-transparent py-2 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
        />
      </div>
    </div>
  );
};
